import React from 'react';

type Props = {
    report         : any
    onSelectReport : callback
}

export default function ModalReportSelect_ReportPreview(props: Props) {

    const onClick = () => {
        const report = typeof props.report.createReport === 'function'
            ? props.report.createReport()
            : props.report
        props.onSelectReport(report)
    }

    return (
        <div className  = "report-preview-card"
             style      = {{
                 width: 335
             }}
             onClick    = {onClick}
        >
            <div className="flex-row-left-top h-100 m-l-30 m-r-30 m-t-30 m-b-20">
                <div className="min-w-35">
                    <div className={Classes(props.report.icon, "w-100-percent h-35 ui5-ico-18")}/>
                </div>
                <div className="m-l-25 flex-1 min-w-0">
                    <div className="ui5-txt-default m-b-8">
                        {props.report.name}
                    </div>
                    <div className="ui5-txt-not-important-tiny lh-14em">
                        {props.report.description}
                    </div>
                </div>
                <div className="item-arrow ui5-ico-9 i5-big-angle-right flex-no-shrink m-t-5"/>
            </div>
        </div>
    );
}
